@if (view === 'cluster') {
  <div class="[ auto-grid auto-grid-min-2xs ] [ p-2xs ]">
    <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
  </div>
}

@if (view === 'reel') {
  <div class="[ reel overflowing reel-item-w-2xs ] [ p-2xs ]">
    <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
  </div>
}

<ng-template #contentTmpl><ng-content></ng-content> </ng-template>
